import { Button, Dialog, DialogTitle } from "@mui/material";
import { Box } from "@mui/system";
import { useAuth } from "hooks";
import { CloseCircle } from "iconsax-react";
import React, { useState, useCallback } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import API from "services/AxiosConfig";
import Preloader from "../Preloader";
import { Spinner } from "components";

export default function ProfileUploader({ open, handleClose }) {
    const [src, setSrc] = useState(null);
    //     const [crop, setCrop] = useState({
    //   unit: '%', // Can be 'px' or '%'
    //   x: 25,
    //   y: 25,
    //   width: 50,
    //   height: 50
    // })
    const [crop, setCrop] = useState();
    const [imageRef, setImageRef] = useState(null);
    const { user } = useAuth();
    const [base64, setBase64] = useState(user.profileImage || "");
    const [loading, setLoading] = useState(false);
    console.log(user.profileImage)
    const handleSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => setSrc(reader.result);
        reader.readAsDataURL(file);
    };

    const onImageLoad = (img) => {
        setImageRef(img);
        const crop = centerCrop(
            makeAspectCrop({ unit: "%", width: 50 }, 1, img.width, img.height),
            img.width,
            img.height
        );
        setCrop(crop);
    };

    const getCroppedImg1 = useCallback(() => {
        if (!imageRef || !crop?.width || !crop?.height) return;

        const canvas = document.createElement("canvas");
        // const scaleX = imageRef.naturalWidth / imageRef.width;
        // const scaleY = imageRef.naturalHeight / imageRef.height;

        // canvas.width = 300; // 👉 Desired final size (resize here)
        // canvas.height = 300;

        // const ctx = canvas.getContext("2d");
        // ctx.drawImage(
        //     imageRef,
        //     crop.x * scaleX,
        //     crop.y * scaleY,
        //     crop.width * scaleX,
        //     crop.height * scaleY,
        //     0,
        //     0,
        //     300,
        //     300
        // );
        // const pixelCrop = {
        //     x: crop.x * scaleX,
        //     y: crop.y * scaleY,
        //     width: crop.width * scaleX,
        //     height: crop.height * scaleY,
        // };

        // // Resize output
        // const outputSize = 300;
        // canvas.width = outputSize;
        // canvas.height = outputSize;

        // const ctx = canvas.getContext("2d");

        // ctx.drawImage(
        //     imageRef,
        //     pixelCrop.x,
        //     pixelCrop.y,
        //     pixelCrop.width,
        //     pixelCrop.height,
        //     0,
        //     0,
        //     outputSize,
        //     outputSize
        // );
        const ctx = canvas.getContext("2d");

        const img = imageRef;

        // If crop is in %, convert it to px
        const scaleX = img.naturalWidth / img.width;
        const scaleY = img.naturalHeight / img.height;

        let pixelX = crop.x * scaleX;
        let pixelY = crop.y * scaleY;
        let pixelW = crop.width * scaleX;
        let pixelH = crop.height * scaleY;

        canvas.width = pixelW;
        canvas.height = pixelH;

        ctx.drawImage(
            img,
            pixelX,
            pixelY,
            pixelW,
            pixelH,
            0,
            0,
            pixelW,
            pixelH
        );

        const base64Image = canvas.toDataURL("image/jpeg", 0.95); // 95% quality
        setBase64(base64Image);

        console.log("Final Base64:", base64Image);
        setLoading(true);
        API.post('/user/profileImage', { image: base64Image, userId: user._id })
            .then((rsp) => {
                if (rsp.data.success) {
                    const storedUser = JSON.parse(localStorage.getItem("user"));
                    const updatedUser = {
                        ...storedUser,
                        user: {
                            ...storedUser.user,
                            profileImage: base64Image   // <-- update inside nested user
                        }
                    };
                    localStorage.setItem("user", JSON.stringify(updatedUser));
                }
                setLoading(false);
                setTimeout(() => { window.location.reload(); }, 50);
            })
            .catch((error) => {
                console.error(error);
            });


    }, [imageRef, crop]);
    const getCroppedImgWorking = useCallback(() => {
        if (!imageRef || !crop?.width || !crop?.height) return;

        const img = imageRef;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // scale from displayed size → original natural size
        const scaleX = img.naturalWidth / img.width;
        const scaleY = img.naturalHeight / img.height;

        const pixelX = Math.round(crop.x * scaleX);
        const pixelY = Math.round(crop.y * scaleY);
        const pixelW = Math.round(crop.width * scaleX);
        const pixelH = Math.round(crop.height * scaleY);

        canvas.width = pixelW;
        canvas.height = pixelH;

        ctx.drawImage(
            img,
            pixelX,
            pixelY,
            pixelW,
            pixelH,
            0,
            0,
            pixelW,
            pixelH
        );

        const base64Image = canvas.toDataURL("image/jpeg", 0.95);
        setBase64(base64Image);

        setLoading(true);
        API.post('/user/profileImage', { image: base64Image, userId: user._id })
            .then((rsp) => {
                if (rsp.data.success) {
                    const storedUser = JSON.parse(localStorage.getItem("user"));
                    const updatedUser = {
                        ...storedUser,
                        user: {
                            ...storedUser.user,
                            profileImage: base64Image
                        }
                    };
                    localStorage.setItem("user", JSON.stringify(updatedUser));
                }
                setLoading(false);
                setTimeout(() => { window.location.reload(); }, 50);
            })
            .catch((error) => console.error(error));

    }, [imageRef, crop]);
    const getCroppedImg = useCallback(() => {
        if (!imageRef || !crop?.width || !crop?.height) return;

        const img = imageRef;

        // canvas for final resized image
        const outputSize = 300; // 🔥 change size here (150 / 200 / 300)
        const canvas = document.createElement("canvas");
        canvas.width = outputSize;
        canvas.height = outputSize;

        const ctx = canvas.getContext("2d");

        // scale from displayed size → original natural size
        const scaleX = img.naturalWidth / img.width;
        const scaleY = img.naturalHeight / img.height;

        const pixelX = Math.round(crop.x * scaleX);
        const pixelY = Math.round(crop.y * scaleY);
        const pixelW = Math.round(crop.width * scaleX);
        const pixelH = Math.round(crop.height * scaleY);

        // Draw cropped area → resized to outputSize
        ctx.drawImage(
            img,
            pixelX,
            pixelY,
            pixelW,
            pixelH,
            0,
            0,
            outputSize,
            outputSize
        );

        const base64Image = canvas.toDataURL("image/jpeg", 0.9);

        setBase64(base64Image);

        setLoading(true);
        API.post('/user/profileImage', { image: base64Image, userId: user._id })
            .then((rsp) => {
                if (rsp.data.success) {
                    const storedUser = JSON.parse(localStorage.getItem("user"));
                    const updatedUser = {
                        ...storedUser,
                        user: {
                            ...storedUser.user,
                            profileImage: base64Image
                        }
                    };
                    localStorage.setItem("user", JSON.stringify(updatedUser));
                }
                setLoading(false);
                setTimeout(() => window.location.reload(), 50);
            })
            .catch((error) => console.error(error));

    }, [imageRef, crop]);

    // return (
    //     <Dialog open={open} onClose={(event, reason) => {
    //         if (reason !== "backdropClick") {
    //             handleClose();
    //         }
    //     }}>
    //         <div className="cancel-icon" style={{ padding: "10px 20px" }}>
    //             <DialogTitle className="main-model-heading">
    //                 Upload Profile Picture
    //             </DialogTitle>
    //             <CloseCircle
    //                 onClick={() => {
    //                     handleClose(false);
    //                 }}
    //                 className="pointer-icon"
    //             />
    //         </div>
    //         <hr className="hr-tag"></hr>
    //         <Box
    //             className="responsive-box"
    //         >
    //             <div style={{ padding: 20 }}>
    //                 <input type="file" accept="image/*" onChange={handleSelect} />

    //                 {src && (
    //                     <ReactCrop
    //                         crop={crop}
    //                         onChange={(_, percentCrop) => setCrop(percentCrop)}
    //                     >
    //                         <img src={src} onLoad={(e) => onImageLoad(e.target)} alt="Source" />
    //                     </ReactCrop>
    //                 )}

    //                 {/* <button onClick={getCroppedImg} style={{ marginTop: 10 }}>
    //                     Crop & Save
    //                 </button> */}
    //                 {loading && <Preloader></Preloader>}
    //                 <Button type="button" variant="contained" color="primary" onClick={getCroppedImg}>
    //                     Crop & Save
    //                 </Button>
    //                 {base64 && (
    //                     <>
    //                         <h3>Preview</h3>
    //                         <img
    //                             src={base64}
    //                             alt="Cropped"
    //                             style={{ width: 150, height: 150, borderRadius: "50%" }}
    //                         />
    //                     </>
    //                 )}
    //             </div>

    //         </Box>
    //     </Dialog>

    // );
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            onClose={(event, reason) => {
                if (reason !== "backdropClick") handleClose();
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 20px"
                }}
            >
                <DialogTitle style={{ padding: 0 }}>Upload Profile Picture</DialogTitle>

                <CloseCircle
                    onClick={() => handleClose(false)}
                    className="pointer-icon"
                    style={{ cursor: "pointer" }}
                />
            </div>

            <hr />

            {/* Main Content */}
            <Box
                sx={{
                    padding: 3,
                    display: "flex",
                    gap: 3,
                    flexDirection: { xs: "column", md: "row" }
                }}
            >
                {/* LEFT — Preview */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: "center"
                    }}
                >
                    <h3 style={{ marginBottom: 10 }}>Preview</h3>

                    {base64 ? (
                        <img
                            src={base64}
                            alt="Preview"
                            style={{
                                width: 200,
                                height: 200,
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "3px solid #ccc"
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                width: 200,
                                height: 200,
                                borderRadius: "50%",
                                border: "2px dashed #bbb",
                                margin: "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#999",
                                fontSize: 14
                            }}
                        >
                            No Preview
                        </div>
                    )}
                </Box>

                {/* RIGHT — Crop Area */}
                <Box
                    sx={{
                        flex: 2,
                        minHeight: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "1px solid #eee",
                        borderRadius: 2,
                        padding: 2
                    }}
                >
                    {src ? (
                        <ReactCrop
                            crop={crop}
                            onChange={(crop) => setCrop(crop)}
                        >
                            <img
                                src={src}
                                onLoad={(e) => onImageLoad(e.target)}
                                alt="Source"
                                style={{ maxHeight: 350 }}
                            />
                        </ReactCrop>
                    ) : (
                        <p style={{ color: "#888" }}>Choose an image to start cropping</p>
                    )}
                </Box>
            </Box>

            {/* FOOTER SECTION */}
            <Box
                sx={{
                    padding: "10px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                {/* File input */}
                <input type="file" accept="image/*" onChange={handleSelect} />

                {/* Right – Save */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {loading && <Spinner />}

                    {!loading && <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={getCroppedImg}
                        disabled={!src}
                    >
                        Crop & Save
                    </Button>}
                </Box>
            </Box>
        </Dialog>
    );

}
